import { useIsMobile } from '@src/hooks/useIsMobile';
import MobileHeader from '@src/ui/templates/Tenant/Header/MobileHeader';
import TenantNavBar from '@src/ui/templates/Tenant/Header/TenantNavBar';
import Sidebar from '@src/ui/templates/Tenant/Sidebar/Sidebar';
import React, { useState } from 'react';

type Props = {
  children: React.ReactNode;
  withoutParentPadding?: boolean;
};

const TenantDefaultLayout = ({ children, withoutParentPadding = false }: Props) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const isMobile = useIsMobile();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className='flex min-h-screen flex-col'>
      {isMobile && (
        <div className='fixed inset-x-0 top-0 z-[99998]'>
          <MobileHeader />
        </div>
      )}
      <div className={`flex flex-1 ${isMobile ? 'pt-[104px]' : ''}`}>
        {!isMobile && (
          <div className='sticky top-0 h-screen overflow-hidden'>
            <div
              className={`h-screen shrink-0 overflow-y-auto transition-all duration-300 ${isSidebarOpen ? 'w-[240px]' : 'w-0'}`}
            >
              <Sidebar />
            </div>
          </div>
        )}
        <div
          className={`flex flex-1 flex-col ${!isMobile && isSidebarOpen ? 'w-[calc(100%-240px)]' : 'w-full'}`}
        >
          {!isMobile && (
            <div
              className='fixed right-0 top-0 z-[99998]'
              style={{ left: isSidebarOpen ? '240px' : '0' }}
            >
              <TenantNavBar
                isSidebarOpen={isSidebarOpen}
                toggleSidebar={toggleSidebar}
              />
            </div>
          )}
          <div
            className={`grow ${!isMobile ? 'pt-[104px]' : ''} ${withoutParentPadding ? '' : 'px-6 py-11'}`}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TenantDefaultLayout;
